import { useEffect, useState } from "react";
import { Loader } from "../../../../common/components/Loader/Loader";
import { TitleHeader } from "../../../../common/components/TitleHeader/TitleHeader";
import useAppStore from "../../../../store/AppStore";
import { CustomDrawer } from "../../../../common/components/Drawer/CustomDrawer";
import { DamagedForm } from "../components/DamagedForm";
import { useDamagedStore } from "../store/DamagedSotre";
import i18n from "../../../../i18n/i18n";
import { LFTableV3 } from "../../../../common/components/LFTable/LFTableV3";
import { ColumnItem } from "../../../../common/models/table";
import { ActionsKey } from "../../../../common/models/Actions";
import { DamagedService } from "../core/_request";
import { HttpStatusCode } from "axios";
import { useSearchParams } from "react-router";
import { DamagedConstant } from "../core/_constant";

export const DamagedList = () => {
  const {
    actioned,
    list,
    pageState,
    totalItems,
    setPageState,
    resetPageState,
    setActioned,
    setList,
  } = useDamagedStore();

  const [searchParams] = useSearchParams();
  const loadType = searchParams.get("type");

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenDrawer, setIsOpernDrawer] = useState<boolean>(false);

  useEffect(() => {
    if (!isOpenDrawer) {
      setActioned({ data: null, action: "no" });
    }
  }, [isOpenDrawer]);

  useEffect(() => {
    return () => {
      setList({
        list: [],
        totalItems: 0,
      } as any);
    };
  }, []);

  useEffect(() => {
    fetchAllList(pageState);
  }, [pageState, loadType]);

  const handleOpenDrawer = () => {
    setIsOpernDrawer((prev: boolean) => !prev);
  };

  const fetchAllList = async (params?: any) => {
    if (loadType) {
      try {
        setIsLoading(true);
        const res = await DamagedService.getAllDamaged({
          loadType,
          ...params,
        });
        if (res?.status === HttpStatusCode.Ok) {
          setList(res?.data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
    } else {
      getOne(item?.id, action);
    }
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await DamagedService.getOneDamaged(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      handleOpenDrawer();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await DamagedService.deleteDamaged(id);
      if (res?.status === HttpStatusCode.NoContent) {
        await fetchAllList(pageState);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    handleOpenDrawer();
    fetchAllList(pageState);
  };

  const cols: ColumnItem[] = [
    {
      key: "name",
      title: "Nom",
      dataIndex: "name",
      show: true,
      isCanSort: true,
    },
    ...(loadType?.toUpperCase() === DamagedConstant.AVARIE_TYPE.container
      ? [
          {
            key: "loadSubType",
            title: "Catégories",
            dataIndex: "loadSubType",
            show: true,
            isCanSort: true,
          },
        ]
      : []),
    {
      key: "loadType",
      title: "Type",
      dataIndex: "loadType",
      show: true,
      isCanSort: true,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <Loader isLoading={isLoading} />
      <TitleHeader
        title={DamagedConstant.getAvarieLabel(loadType ?? "") ?? ""}
        isEnableAdd
        onClickOnAdd={handleOpenDrawer}
        isSHowBack
      />

      <div className="mt-4">
        <LFTableV3
          columns={cols}
          data={list}
          params={pageState}
          onAction={onActionClick}
          isCanEdit={() => true}
          isCanDelete={() => true}
          onSearch={handleSetParams}
          onSort={handleSetParams}
          onResetSearch={resetPageState}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={handleSetParams}
        />
      </div>

      {isOpenDrawer && (
        <CustomDrawer
          title={
            actioned?.action === "read"
              ? "Détails"
              : actioned?.action === "update"
              ? "Modification"
              : i18n.t("NEW")
          }
          isOpen={isOpenDrawer}
          onClose={handleOpenDrawer}
        >
          <DamagedForm
            onFinish={onFinishAction}
            {...(actioned?.action === "read" || actioned?.action === "update"
              ? {
                  initialValue: actioned.data,
                  type: actioned.action,
                }
              : {})}
          />
        </CustomDrawer>
      )}
    </div>
  );
};
